// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1ad62a5c60095f77e65c893c62e25b2a7e362f97.chunk.bundle.js";
};